module.exports = __webpack_public_path__ + "static/media/slide2.28731895.jpg";